import requestBase from '@/utils/request-base'

const request = function(config) {
  config = Object.assign({}, config, {
    // 产品化并不会和lenovo user 打交道，所以没有必要放到env 下
    baseURL: '"https://user.lenovo.com.cn"',
    timeout: 60 * 1000, // request timeout
    headers: {
      'Accept': 'application/lenovo.ucenter.api.v2+json'
    },
    // 设置允许服务器端写cookie
    withCredentials: true
  })
  // return requestBase(config).then((response) => {
  //   return response.data
  // })
  return requestBase(config)
}

// lenovoid-登陆【普通】
export function login(param) {
  return request({
    url: `/v2/login`,
    method: 'post',
    data: param
  })
}

// lenovoid-登陆【快速】
export function quickLogin(param) {
  return request({
    url: `/v2/login/quick`,
    method: 'post',
    data: param
  })
}

// 发送短信验证码
export function validation(phone) {
  return request({
    url: `/v2/login/code/${phone}`,
    method: 'post'
  })
}

// 发送短信验证码
export function checkStatus(param) {
  return request({
    url: `/v2/login/status`,
    method: 'post',
    data: param
  })
}

// 换取cube_id
export function getVisitorCubeId(param) {
  return requestBase({
    url: `/api/csc/login`,
    method: 'post',
    data: param
  })
}

// 游客登陆
export function getCubeId() {
  return requestBase({
    url: `/api/csc/login/anon`,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login/index.js